module.exports = __webpack_public_path__ + "img/derc.14337da7.jpg";